import { useCallback, useContext } from 'react';
import { CopilotChannelContext } from '../CopilotChannelContext';
export function useSendOnCopilotChannel(topic) {
  const {
    channel
  } = useContext(CopilotChannelContext);
  return useCallback(data => {
    if (!channel) {
      return;
    }
    channel.postToTopic(topic, data);
  }, [channel, topic]);
}